import { array, boolean, defineAction, number, object, string } from '~/prix'
import insightSolutionSearchAction from './insightSolutionSearch.action.json'

const insightSolutionSearchDefinition = defineAction({
  ...insightSolutionSearchAction,

  input: object({
    search: string().isOptional(),
    page: number().isOptional(),
    limit: number().isOptional(),
  }),
  output: object({
    items: array(
      object({
        description: string(),
        productCode: string().isOptional(),
      }),
    ),
    hasMore: boolean().isOptional(),
  }),
})

export default insightSolutionSearchDefinition
